import type { UseFetchOptions } from "nuxt/app";

export function useApi<T>(
    url: string | Request | Ref<string | Request> | (() => string | Request),
    options: UseFetchOptions<T> = {}
) {
    options.headers = {
        ...useRequestHeaders([
            "X-Forwarded-For",
            "X-Datadome-IsBot",
            "X-Datadome-Botname",
            "X-Datadome-Botfamily",
            "X-Datadome-Ruletype",
            "user-agent",
        ]),
        ...options.headers,
    };
    // NOTE: xsrfToken header and language query string is set in $api

    return useFetch(url, {
        ...options,
        $fetch: useNuxtApp().$api as typeof $fetch,
    });
}
